/*
  lp-help-faq — accordion rows for the LP · Help FAQ sections.
  One delegated listener serves every FAQ section on the page, including sections the theme
  editor adds later, so the file can be included by each section without side effects.
  Every row opens and closes on its own (several answers can be open at once). The button's
  aria-expanded drives the CSS animation; the panel is hidden from assistive tech and made
  inert while closed.
*/
(() => {
  if (window.lpHelpFaqReady) return;
  window.lpHelpFaqReady = true;

  const setOpen = (button, open) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.toggleAttribute('inert', !open);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-lp-help-faq-toggle]');
    if (button) setOpen(button, button.getAttribute('aria-expanded') !== 'true');
  });

  // Theme editor: selecting a question block in the sidebar opens its answer.
  document.addEventListener('shopify:block:select', (event) => {
    const button = event.target.querySelector && event.target.querySelector('[data-lp-help-faq-toggle]');
    if (button) setOpen(button, true);
  });
})();
